<template>
  <div style="margin-top: -10px">
    <header>
      <!-- We want header content here -->
      <b-row
        class="border-bottom px-pad justify-content-center align-items-center"
        style="height: 42px"
      >
        <b-col cols="6" class="px-0">
          <h2 class="page-title text-truncate mb-2">{{ "Import " + title }}</h2>
        </b-col>
        <b-col cols="6" class="text-right px-0">
          <!-- <a @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none mb-2"></i>
          </a> -->
           <span class="cursor_pointer" @click="$emit('redirectPage')">
          <i class="la la-remove la-lg text-decoration-none mb-2"></i>
        </span>
        </b-col>
      </b-row>
    </header>
    <form-wizard ref="wizard" shape="circle" color="#3498db" title subtitle class="import-block">
      <wizard-step
        slot-scope="props"
        slot="step"
        :tab="props.tab"
        :transition="props.transition"
        :index="props.index"
      ></wizard-step>
      <!-- Progress bar for tab movement -->
      <b-progress class="progress-xs" variant="gray-light" :value="progress" :max="3" />
      <!-- Footer submit Button -->
      <b-button
        slot="prev"
        variant="primary"
        @click="progress = progress - 1"
        :disabled="submitted == true"
      >
        <i class="fa fa-caret-left" /> Previous
      </b-button>
      <b-button
        slot="next"
        variant="primary"
        @click.stop="nextTab"
        :disabled="file_uploaded == 0 || submitted == true"
      >
        <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i> Next
        <i class="fa fa-caret-right" />
      </b-button>

      <b-button
        type="submit"
        slot="finish"
        :disabled="list.count == 0 || submitted == true"
        variant="success"
        @click="finishTab"
      >
        <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Finish
        <i class="fa fa-check" />
      </b-button>
      <tab-content title="Configure" class="px-0">
        <div class="content-container mt-5 p-0">
          <b-form-group>
            <upload-excel-component
              :on-success="handleSelectedFile"
              :before-upload="beforeUpload"
              class="mb-1"
            />
            <small class="text-muted">
              Maximum File Size: 1 MB | File Format: CSV or XLSX or XLS | Excel
              rows do not exceed 1000 rows.
            </small>
          </b-form-group>
          <p class="mt-2 cursor_pointer" @click="downloadWithAxios">
            <span class="btn-link">Download a sample file</span>
            <span class="la la-download ml-2 la-lg text-link"></span>
          </p>

          <b-form-group
            label=" File Name"
            label-cols="4"
            label-class="required"
            label-for="file name"
          >
            <label class="col-form-label">{{ file_name }}</label>
          </b-form-group>
          <b-form-group
            v-if="show_dup_handle.show"
            label="Duplicate Handling"
            label-cols="4"
            label-class="required"
            label-for="dup-handling"
          >
            <div class="col text-left">
              <b-form-radio-group v-model="allow_duplicate">
                <b-form-radio value="0">Skip</b-form-radio>
                <b-form-radio value="1">Overwrite</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-form-group>
        </div>
      </tab-content>
      <tab-content title="Map Fields">
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12" xs="12" style="max-width: 800px">
            <h5 class="fw-semi-bold">Map your fields to {{ "import " + title }} fields</h5>
            <p class="fw-semi-bold">Note: Duplicate rows will be detected by marked fields</p>
            <p v-if="show_message != ''" class="fw-semi-bold">{{ show_message }}</p>
            <table
              class="table table-bordered import-table-border mt-4"
              style="margin-bottom: 90px !important"
            >
              <thead>
                <tr>
                  <th></th>
                  <th>Books Field</th>
                  <th>Your Field</th>
                  <th style="min-width: 225px">Format</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in excel_data" :key="index">
                  <td class="text-center align-middle pr-0">
                    <!-- <b-form-group class="abc-checkbox" v-if="item.unique == 1">
                      <b-form-checkbox
                        type="checkbox"
                        :id="item.field_name"
                        :true-value="item.field_name"
                        :false-value="0"
                        @input="unique_field=item.field_name"
                      ></b-form-checkbox>
                    </b-form-group>-->
                    <b-form-radio
                      v-if="item.unique == 1"
                      v-model="unique_field"
                      name="unique_field"
                      :value="item.field_name"
                      :disabled="
                        item.field_name == 'pdt_name' && allow_duplicate_name
                      "
                    ></b-form-radio>
                  </td>
                  <td class="align-middle" :class="{ 'text-danger': item.is_required }">
                    {{ item.actual_label }}
                    <span class="text-danger">
                      {{
                      item.is_required ? "*" : ""
                      }}
                    </span>
                  </td>
                  <td>
                    <v-select
                      v-validate="{
                        required:
                          item.is_required || unique_field == item.field_name,
                      }"
                      :clearable="
                        item.excel_label != '' && item.excel_label != null
                      "
                      size="sm"
                      v-model.trim="item.excel_label"
                      :options="excel_field_list"
                      placeholder="Choose your field"
                      @input="$event == null ? (item.excel_label = '') : ''"
                    ></v-select>
                  </td>
                  <td>
                    <div v-if="item.datatype == 'date'" class="d-flex">
                      <v-select
                        :clearable="false"
                        :options="date_format_list"
                        v-model="date_format[item.field_name]"
                        label="label"
                        index="value"
                        style="width: calc(100% - 20px)"
                      ></v-select>
                      <span class="my-auto mx-auto">
                        <i
                          class="fa fa-info-circle"
                          v-b-tooltip.right="
                            'The Date Format indicates the way your dates are represented on the file to be imported. Ensure that you have selected the exact date format as on your file before you import. For example: If the date on your CSV file is 06-02-2016 then select DD-MM-YYYY as the Date Format.'
                          "
                        ></i>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Preview">
        <div class="import-preview mt-7">
          <div class="alert alert-danger" v-if="list.count == 0">None of the rows can be imported</div>
          <div class="alert alert-info" v-else>
            {{ list.count }} of {{ excelcontents.body.length }} {{ title }} in
            your file are ready to be imported.
          </div>
          <ul class="list-unstyled">
            <li>
              <div class="collapsed" v-b-toggle="list.count == 0 ? '' : 'importcount'">
                <i class="fa fa-angle-right mr-3" style="font-size: 18px"></i>
                {{ title }} that are ready to be imported({{ list.count }})
              </div>
              <b-collapse class="ml-5 mt-3" id="importcount" style="height: 0px">
                <ul style="list-style-type: circle">
                  <li>
                    {{ title }} to be created ({{
                    parseInt(list.count) - parseInt(list.duplicate_count)
                    }})
                  </li>
                  <li>
                    {{ title }} waiting to be overwritten ({{
                    list.duplicate_count
                    }})
                  </li>
                </ul>
              </b-collapse>
            </li>
            <li>
              <div class="collapsed" v-b-toggle.skippedrecords>
                <i
                  class="mr-3"
                  :class="{
                    'fa fa-angle-right': !skippedrecords,
                    'fa fa-angle-down': skippedrecords,
                  }"
                  style="font-size: 18px"
                ></i>
                <span class="text-blue cursor_pointer">No. of Records skipped</span>
                <span style="color: #d12e1e">({{ list.skipped_records }})</span>
              </div>
              <b-collapse
                class="ml-6 mt-3"
                id="skippedrecords"
                v-model="skippedrecords"
                style="height: 0px"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="item in list.skip_message" :key="item.id">
                      <td>{{ item }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </li>
          </ul>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import vSelect from "vue-select";
import { notificationMixin } from "@/mixins/notification";
import axios from "axios";
import { formatDate } from "@/mixins/formatDate";

export default {
  mixins: [notificationMixin, formatDate],
  components: {
    UploadExcelComponent,
    vSelect
  },

  props: [
    "title",
    "url",
    "items",
    "check_validation",
    "sample_file_name",
    "warehouse_id",
    "allow_duplicate_name",
    "show_message",
    "show_dup_handle"
  ],
  data() {
    return {
      skippedrecords: false,
      file_name: "",
      allow_duplicate: this.show_dup_handle.value,
      excelcontents: { header: {}, body: {} },
      file_uploaded: 0,
      excel_field_list: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      list: {},
      unique_field: "",
      progress: 1,
      submitted: false,
      date_format: {},
      numeric_format: [],
      date_format_list: [
        {
          label: "ddd, MMMM DD, YYYY",
          value: "D, F d, Y"
        },
        {
          label: "MMMM DD, YYYY",
          value: "F d,Y"
        },
        {
          label: "MMM DD, YYYY",
          value: "M d,Y"
        },
        {
          label: "DD MMMM YYYY",
          value: "d F Y"
        },
        {
          label: "DD MMM YYYY",
          value: "d M Y"
        },
        {
          label: "DD-MMM-YYYY",
          value: "d-M-Y"
        },
        {
          label: "DD/MMM/YYYY",
          value: "d/M/Y"
        },
        {
          label: "YYYY-MM-DD",
          value: "Y-m-d"
        },
        {
          label: "DD-MM-YYYY",
          value: "d-m-Y"
        },
        {
          label: "MM-DD-YYYY",
          value: "m-d-Y"
        },
        {
          label: "YYYY/MM/DD",
          value: "Y/m/d"
        },
        {
          label: "DD/MM/YYYY",
          value: "d/m/Y"
        },
        {
          label: "MM/DD/YYYY",
          value: "m/d/Y"
        },
        {
          label: "YYYY.MM.DD",
          value: "Y.m.d"
        },
        {
          label: "DD.MM.YYYY",
          value: "d.m.Y"
        },
        {
          label: "MM.DD.YYYY",
          value: "m.d.Y"
        },
        {
          label: "YY-MM-DD",
          value: "y-m-d"
        },
        {
          label: "DD-MM-YY",
          value: "d-m-y"
        },
        {
          label: "MM-DD-YY",
          value: "m-d-y"
        },
        {
          label: "YY/MM/DD",
          value: "y/m/d"
        },
        {
          label: "DD/MM/YY",
          value: "d/m/y"
        },
        {
          label: "MM/DD/YY",
          value: "m/d/y"
        },
        {
          label: "YY/MM/DD",
          value: "y.m.d"
        },
        {
          label: "DD.MM.YY",
          value: "d.m.y"
        },
        {
          label: "MM.DD.YY",
          value: "m.d.y"
        }
      ],
      excel_data: []
    };
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    var temp = this;
    this.items.map(function(value) {
      if (value.datatype == "amount" || value.datatype == "decimal") {
        temp.numeric_format.push(value.field_name);
      } else if (value.datatype == "date") {
        temp.date_format[value.field_name] = "Y-m-d";
      }
    }, 0);
  },
  methods: {
    getItems() {
      return this.items;
    },
    finishTab() {
      this.submitted = true;
      this.$emit("import");
    },
    displayNotification(message, type) {
      window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message: message,
        type: type,
        showCloseButton: true
      });
    },
    handleSelectedFile(convertedData) {
      this.excel_field_list = [];
      this.excel_data = [];
      this.file_name = convertedData.file_name;
      this.excelcontents = convertedData;
      this.file_uploaded = 1;
    },
    downloadWithAxios() {
      axios({
        method: "get",
        url: this.url,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(() => {});
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.sample_file_name); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    beforeUpload(file) {
      this.excel_field_list = [];
      this.excel_data = [];
      if (!file) {
        this.displayNotification("Please choose file to upload", "error");
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      return false;
    },

    nextTab() {
      this.submitted = true;
      if (this.$refs.wizard.activeTabIndex == 0) {
        if (this.file_uploaded == 0) {
          this.displayNotification("Please choose file to upload", "danger");
          this.submitted = false;
          return false;
        }
        if (this.excelcontents.header.length == 0) {
          this.displayNotification("columns mismatched", "danger");
          this.submitted = false;
          return false;
        }
        if (this.excelcontents.header.includes("")) {
          this.displayNotification(
            "File contains empty string as column header(s). Please check the content and try again.",
            "danger"
          );
          this.submitted = false;
          return false;
        }
        if (this.excelcontents.body.length > 1000) {
          this.displayNotification(
            "Excel rows do not exceed 1000 rows.",
            "danger"
          );
          this.submitted = false;
          return false;
        }
        this.unique_field = "";
        this.excel_data = this.getItems();
        this.excelcontents.header.map(key => {
          this.excel_field_list.push(key);
          for (var i = 0; i < this.excel_data.length; i++) {
            if (key == this.excel_data[i].actual_label) {
              this.excel_data[i].excel_label = key;
            }
          }
        });
        this.$refs.wizard.nextTab();
        this.progress = this.$refs.wizard.activeTabIndex + 1;
        this.submitted = false;
      } else if (this.$refs.wizard.activeTabIndex == 1) {
        if (this.unique_field == "") {
          this.displayNotification(
            "Please atleast choose one field as unique field",
            "danger"
          );
          this.submitted = false;
        } else {
          var header_used = [];
          var unmapped_field = [];
          this.excel_data.map(function(value) {
            if (value.excel_label != "") {
              header_used.push(value);
            } else {
              unmapped_field.push(value.field_name);
            }
          }, 0);
          if (
            header_used.length ==
            new Set(header_used.map(x => x.excel_label)).size
          ) {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.matchcolumns(JSON.stringify(this.excelcontents.body))
                  .then(response => {
                    this.$store
                      .dispatch(
                        this.check_validation,
                        JSON.stringify({
                          item_details: response,
                          allow_duplicate: this.allow_duplicate,
                          unique_field: this.unique_field,
                          numeric_format: this.numeric_format,
                          date_format: this.date_format,
                          import_columns: this.excel_data,
                          warehouse_id: this.warehouse_id
                            ? this.warehouse_id
                            : "",
                          unmapped_field: unmapped_field,
                          app_id: process.env.VUE_APP_APP_ID
                        })
                      )
                      .then(response => {
                        this.submitted = false;
                        this.list = response;
                        this.$refs.wizard.nextTab();
                        this.progress = this.$refs.wizard.activeTabIndex + 1;
                      });
                  })
                  .catch(() => {
                    this.displayNotification(
                      "Some error occured in excel mapping/ excel values.",
                      "danger"
                    );
                  });
              } else {
                this.submitted = false;
                this.displayNotification(
                  "Select all required fields",
                  "danger"
                );
              }
            });
          } else {
            this.submitted = false;
            this.displayNotification(
              "Same Column header has been matched with multiple columns.",
              "danger"
            );
          }
        }
      }
    },

    matchcolumns(excelbody) {
      return new Promise(resolve => {
        var i;
        var body = JSON.parse(excelbody);
        body.map(item => {
          for (i = 0; i < this.excel_data.length; i++) {
            item[this.excel_data[i].field_name] =
              item[this.excel_data[i].excel_label];
            delete item[this.excel_data[i].excel_label];
          }
        });
        resolve(body);
      });
    }
  }
};
</script>
<style src="./Import.scss" lang="scss" ></style>
<style scoped>
.alert-info {
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #3a87ad;
}
.alert-danger {
  background-color: #ffecec !important;
  border-color: #ffdde2 !important;
  color: #b94a48 !important;
}
.import-preview .list-unstyled > li {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
</style>
<style >
.vue-form-wizard .wizard-nav li.active {
  background-color: #fff !important;
}
.vue-form-wizard .wizard-nav li.active span {
  color: #211f1f !important;
}
.vue-form-wizard .wizard-nav li {
  background-color: #fff !important;
}
.wizard-icon-container {
  background-color: rgb(52, 152, 219) !important;
}
.vue-form-wizard .wizard-icon-circle {
  border: 1px solid rgb(52, 152, 219) !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 35px !important;
  height: 35px !important;
  font-size: 17px !important;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 20px !important;
}
.vue-form-wizard .wizard-nav li {
  padding: 0rem !important;
}
.progress-bar.bg-gray-light {
  background-color: rgba(86, 151, 208, 0.31) !important;
}
.vue-form-wizard .wizard-icon-circle {
  outline: none !important;
}
.vue-form-wizard .wizard-tab-container {
  background: #ffffff !important;
}
i.wizard-icon {
  font-style: normal !important;
}
.vue-form-wizard .wizard-card-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 3;
  padding: 10px 20px !important;
  width: calc(100% - 200px) !important;
  margin-left: 200px !important;
}
.root.sidebarClose.sidebarStatic
  div.wrap
  div.vue-form-wizard
  .wizard-card-footer {
  width: calc(100% - 200px) !important;
  margin-left: 200px !important;
}

.root.sidebarClose div.wrap div.vue-form-wizard .wizard-card-footer {
  width: calc(100% - 50px) !important;
  margin-left: 50px !important;
}
.vue-form-wizard .wizard-nav li span {
  color: #000 !important;
  font-weight: 700 !important;
}
.import-block .progress-xs {
  height: 2px !important;
}
.progress {
  background-color: #fafbff !important;
}
.content-container {
  background: #fff;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}
.page-title {
  margin-bottom: 14px;
  font-size: 21px;
  margin-top: 0px;
}
</style>

